import { useQuery } from '@tanstack/react-query';

import { useAuthContext } from 'src/auth/hooks';
import { getChatsUnreadCount } from 'src/api';
import { useChatRealtime } from 'src/services/chat-socket';
import { chatKeys } from 'src/utils/query-keys';
import { isSuccessResponse } from 'src/utils/response-type-guards';

const DEGRADED_POLL_MS = 60 * 1000;

export const useChatsUnreadCount = () => {
  const { platformId } = useAuthContext();
  const { degradedChannels } = useChatRealtime();

  const { data } = useQuery({
    queryKey: chatKeys.unread(platformId),
    queryFn: () => getChatsUnreadCount(),
    staleTime: Infinity,
    refetchOnWindowFocus: true,
    refetchInterval: degradedChannels.length ? DEGRADED_POLL_MS : false,
    enabled: !!platformId,
  });

  return data && isSuccessResponse(data) ? data.total_unread : 0;
};
